
export enum CmsIds {
    Term = 96930,
    Policy = 96932,
    BySignupTermAndPolicy = 96927,
    AffiliateAgrement = 66292,
    AgreeToTermsAndCond = 76270,
    SomethingWrong = 66587,
    RecieveUpdateText  = 85158,
    CreateAccount = 66302,
    PleaseAcknowledge = 66550,
    ThanksForBePartner = 84128,
    CoporatePleaseClickLink = 84130,
    RedirectToSignin = 277303,
    PartnerTypeFieldLabel = 565400,
    PartnerTypePlaceholder = 565401,
    PartnerTypeAffiliateLabel = 565402,
    PartnerTypeAmbassadorLabel = 565403,
    AmbassadorAgreement = 565404,
    SignupTypePageTitle = 570001,
    PartnerTypeRequired = 570002,
    AgreementPlaceholder = 570003,
    SignupAsAmbassador = 570004,
    SignupAsAffiliate = 570005,
    AffiliateInstead = 570021,
    AmbassadorInstead = 570022,
    SwitchPartnerTypeClickHere = 570023,
    SignupTitle = 76297,
}
